import { Injectable } from "@angular/core";
import { BasePostProvider } from "@tendercuts/http";
import { GenericServerResponse } from "@tendercuts/models";
import { LoginServices } from "../login";
import { EndPoint } from "../base";
import "rxjs/add/operator/map";
import { HttpClient, HttpParams } from "@angular/common/http";

@Injectable({ providedIn: "root" })
export class OtpService extends BasePostProvider<GenericServerResponse> {
  constructor(
    public http: HttpClient,
    public loginService: LoginServices,
    public endpointService: EndPoint
  ) {
    super(http);
  }

  get model() {
    return GenericServerResponse;
  }

  get isAuthenticatedEndpoint() {
    return true;
  }
  get authProtocol() {
    return this.loginService;
  }

  get endpoint() {
    return this.endpointService.sendOtp();
  }

  /**
   * @override
   * Disable caching for this service as we want OTP to be generated everytime
   */
  get isCachable() {
    return false;
  }

  getParams(
    billAmount: number,
    storeId: string,
    phone: string,
    gRCToken: string
  ) {
    let params = {
      billing_amount: billAmount,
      store_id: storeId,
      phone: phone,
      re_response: gRCToken,
    };

    return params;
  }
}
